import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { AutocompleteOption } from 'blip-ds/dist/types/components/autocomplete/autocomplete-select-interface';
import './ProfileSection.scss';

interface AutocompleteElement extends HTMLElement {
  isOpen?: boolean;
  searchOnlyTitle?: boolean;
}

interface ProfileSectionProps {
  account: string | undefined;
  setAccount: (account: string) => void;
  pages: AutocompleteOption[];
  loading: boolean;
  disabled?: boolean;
}

export const ProfileSection: React.FC<ProfileSectionProps> = ({
  account,
  setAccount,
  pages,
  loading,
  disabled = false,
}) => {
  const { t } = useTranslation();
  const pagePickerRef = useRef<AutocompleteElement | null>(null);

  useEffect(() => {
    const pagePicker = pagePickerRef.current;
    if (!pagePicker) return undefined;

    pagePicker.searchOnlyTitle = false;

    const handleAccountSelection = (event: Event) => {
      const value = (event as CustomEvent<{ value?: string }>).detail?.value;
      if (typeof value !== 'string' || !pages.some((page) => page.value === value)) return;
      setAccount(value);
      queueMicrotask(() => {
        pagePicker.isOpen = false;
      });
    };

    pagePicker.addEventListener('optionSelected', handleAccountSelection, true);
    return () => pagePicker.removeEventListener('optionSelected', handleAccountSelection, true);
  }, [pages, setAccount]);

  return (
    <bds-paper class="scheduler-section scheduler-profile-section" border width="auto">
      <bds-grid direction="column" gap="2" lg="6" md="6" sm="6" xs="6" padding="none">
        <div className="profile-section_header">
          <bds-typo class="profile-section_header-title" tag="h4" variant="fs-20" bold="bold" margin={false}>
            {t('profilesAndChannels')}
          </bds-typo>
          <bds-typo class="profile-section_header-subtitle" tag="p" variant="fs-12">
            {t('selectProfilesChannels')}
          </bds-typo>
        </div>
        <bds-autocomplete
          label={t('socialNetwork')}
          value="facebook_instagram"
          placeholder={t('instagram')}
          selection-type="single"
          disabled={true}
        ></bds-autocomplete>
        <bds-autocomplete
          ref={pagePickerRef as any}
          label={t('instagramPage')}
          loading={loading}
          disabled={disabled}
          value={account}
          placeholder={t('selectInstagramPage')}
          selection-type="single"
        >
          {pages.map(page => (
            <bds-select-option
              key={page.value}
              value={page.value}
            >
              {page.label}
            </bds-select-option>
          ))}
        </bds-autocomplete>
      </bds-grid>
    </bds-paper>
  );
};